import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
function Skeleton({ className, ...props }) {
    return /*#__PURE__*/ jsx("div", {
        className: cn('tw-skeleton tw-relative tw-flex tw-overflow-hidden tw-rounded-1 tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600', className),
        ...props
    });
}
export { Skeleton };
